import React, { useState, useEffect } from "react";
import { useFormikContext } from "formik";
import CustomDataTableEditable from "../../../../partials/content/CustomDataTableEditable";
import { getUserMasterDataAPI } from "../../../../services/usersService";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import { Badge } from "react-bootstrap";
import Illustration from "../../../../partials/content/Illustration";
import {
  checkRegexEmail,
  checkRegexPhoneNumber,
} from "../../../../utils/utils";
function ConfirmUploadedUsers() {
  const { values, handleSubmit } = useFormikContext();
  const [auth, setAuth] = useState({});
  const [authorizationOptions, setAuthorizationOptions] = useState([]);
  const [userGroupOptions, setUserGroupOptions] = useState([]);

  useEffect(() => {
    function getUserMasterData() {
      getUserMasterDataAPI().then((response) => {
        const { data, auth } = response.data;
        const { userGroups, authorizations } = data;
        setMasterData(userGroups, authorizations);
        setAuth(auth);
      });
    }
    getUserMasterData();
  }, []);
  return (
    <>
      {values.length > 0 ? (
        <CustomDataTableEditable
          data={values}
          buttons={[
            {
              name: "Upload",
              onClick: (e) => {
                handleSubmit(e);
              },
              icon: "fas fa-upload",
              color: "success",
            },
          ]}
          onRowEditComplete={(e) => {
            let { newData, index } = e;
            values[index] = newData;

            /*Update selected dropdown label*/
            const authName = authorizationOptions.filter(function(dropdown) {
              return dropdown.value === values[index].authID;
            });
            if (authName.length > 0) {
              values[index].authName = authName[0].label;
            } else {
              values[index].authID = 0;
              values[index].authName = "";
            }

            const groupName = userGroupOptions.filter(function(dropdown) {
              return dropdown.value === values[index].groupID;
            });
            if (groupName.length > 0) {
              values[index].groupName = groupName[0].label;
            } else {
              values[index].groupID = 0;
              values[index].groupName = "";
            }

            /*Update mass upload status ID*/
            values[index].statusID = 1;

            if (values[index].firstName === "") {
              values[index].statusID = 0;
            }
            if (values[index].lastName === "") {
              values[index].statusID = 0;
            }
            if (values[index].phone === "") {
              values[index].statusID = 0;
            } else {
              if (checkRegexPhoneNumber(values[index].phone) !== true) {
                values[index].statusID = 0;
              }
            }
            if (values[index].email === "") {
              values[index].statusID = 0;
            } else {
              if (checkRegexEmail(values[index].email) !== true) {
                values[index].statusID = 0;
              }
            }
            if (values[index].username === "") {
              values[index].statusID = 0;
            }
            if (values[index].password === "") {
              values[index].statusID = 0;
            }
            if (values[index].authID === 0 && values[index].authName !== "") {
              values[index].statusID = 0;
            }
            if (values[index].groupID === 0 && values[index].groupName !== "") {
              values[index].statusID = 0;
            }
          }}
          columns={[
            {
              header: "Mass Upload Status",
              field: "statusID",
              body: (rowData) => {
                if (rowData.statusID === 0) {
                  return <Badge variant="danger">Not Ready To Upload</Badge>;
                } else if (rowData.statusID === 1) {
                  return <Badge variant="success">Ready To Upload</Badge>;
                } else if (rowData.statusID === 2) {
                  return <Badge variant="primary">Successfully Uploaded</Badge>;
                } else if (rowData.statusID === 3) {
                  return (
                    <React.Fragment>
                      <span className="mr-3">
                        <BootstrapTooltip title={rowData.message}>
                          <span className="mr-1">
                            <i className="fas fa-exclamation-triangle kt-font-warning"></i>
                          </span>
                        </BootstrapTooltip>
                        <Badge variant="danger">Unsuccessfully Uploaded</Badge>
                      </span>
                    </React.Fragment>
                  );
                }
              },
              sortable: true,
              filter: true,
            },
            {
              header: "First Name",
              field: "firstName",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.firstName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="First Name is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.firstName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.firstName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.firstName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Last Name",
              field: "lastName",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.lastName === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Last Name is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.lastName}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.lastName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.lastName}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Phone Number",
              field: "phone",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.phone === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Phone Number is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.phone}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.phone !== "" ? (
                      <React.Fragment>
                        {checkRegexPhoneNumber(rowData.phone) === true ? (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="The data is acceptable">
                                <span className="mr-1">
                                  <i className="fas fa-check-circle kt-font-success"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">{rowData.phone}</span>
                            </span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX">
                                <span className="mr-1">
                                  <i className="fas fa-times-circle kt-font-danger"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">{rowData.phone}</span>
                            </span>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Email",
              field: "email",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.email === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Email is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.email}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.email !== "" ? (
                      <React.Fragment>
                        {checkRegexEmail(rowData.email) === true ? (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="The data is acceptable">
                                <span className="mr-1">
                                  <i className="fas fa-check-circle kt-font-success"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">{rowData.email}</span>
                            </span>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                            <span className="mr-3">
                              <BootstrapTooltip title="Email must be valid. e.g. joe@invifo.com">
                                <span className="mr-1">
                                  <i className="fas fa-times-circle kt-font-danger"></i>
                                </span>
                              </BootstrapTooltip>
                              <span className="mr-1">{rowData.email}</span>
                            </span>
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Username",
              field: "username",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.username === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Username is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.username}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.username !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.username}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "Password",
              field: "password",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.password === "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Password is required">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.password}</span>
                        </span>
                      </React.Fragment>
                    ) : rowData.password !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.password}</span>
                        </span>
                      </React.Fragment>
                    ) : null}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "text",
            },
            {
              header: "User Group",
              field: "groupID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.groupID === 0 && rowData.groupName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="User Group is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.groupName}</span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.groupName}</span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: userGroupOptions,
            },
            {
              header: "Authorization",
              field: "authID",
              body: (rowData) => {
                return (
                  <React.Fragment>
                    {rowData.authID === 0 && rowData.authName !== "" ? (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="Authorization is not found in master data. Please select the existing data provided">
                            <span className="mr-1">
                              <i className="fas fa-times-circle kt-font-danger"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.authName}</span>
                        </span>
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        <span className="mr-3">
                          <BootstrapTooltip title="The data is acceptable">
                            <span className="mr-1">
                              <i className="fas fa-check-circle kt-font-success"></i>
                            </span>
                          </BootstrapTooltip>
                          <span className="mr-1">{rowData.authName}</span>
                        </span>
                      </React.Fragment>
                    )}
                  </React.Fragment>
                );
              },
              sortable: true,
              filter: true,
              editorOption: "dropdown",
              dropdownOptions: authorizationOptions,
            },
          ]}
        />
      ) : (
        <Illustration
          imageSource="INVIFO Setup.png"
          description="Good Start! You're ready for Mass Upload!"
          guidance="Hint: upload master data based on template provided"
          descriptionLeftIcon="fas fa-info-circle kt-font-success"
        ></Illustration>
      )}
    </>
  );
  function setMasterData(userGroups = [], authorizations = []) {
    let userGroupOptionsTmp = [];
    let authorizationOptionsTmp = [];
    if (typeof userGroups !== "undefined") {
      userGroups.forEach((userGroup) => {
        userGroupOptionsTmp.push({
          value: userGroup.ID,
          label: userGroup.groupName,
        });
      });
    }

    if (typeof authorizations !== "undefined") {
      authorizations.forEach((authorization) => {
        authorizationOptionsTmp.push({
          value: authorization.ID,
          label: authorization.authName,
        });
      });
    }
    setUserGroupOptions(userGroupOptionsTmp);
    setAuthorizationOptions(authorizationOptionsTmp);
  }
}

export default ConfirmUploadedUsers;
